// @flow
import config from '../configs/AppConfigs';

const ID = `${config.moduleName}/actions/configActions.ts`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const APPEND_SERVER_CONFIG = createActionName('APPEND_SERVER_CONFIG');

export const appendServerConfig = (payload: any) => {
  const { ...rest } = payload;
  config.extends(rest);
  console.log(
    '%c%s',
    'color: #ccc',
    `appendServerConfig ${config.moduleName}`,
    config,
  );
  return {
    type: APPEND_SERVER_CONFIG,
    payload,
  };
};
